import { Loadable } from '../../Loadable';

export const AsyncAddTimeSlot = Loadable(() => import('./Add'));
export const AsyncEditTimeSlot = Loadable(() => import('./Edit'));
export const AsyncTimeSlotList = Loadable(() => import('./List'));
